import axios from 'axios'
import {
  MessageBox,
  Message
} from 'element-ui'
import store from '@/store'
import sha256 from 'crypto-js/sha256'
import router from '@/router'
import {
  getToken,
  removeToken
} from '@/utils/auth'

// create an axios service
const service = axios.create({
  // baseURL:process.env.NODE_ENV == 'production'
  //   ? 'http://192.168.110.122:9004'
  //   : '/api',
  //CCM
  // baseURL:process.env.NODE_ENV == 'production'
  // ? 'https://im.ccgmmundo.com'
  // : '/api',
  // CMG
  // baseURL:process.env.NODE_ENV == 'production'
  // ? 'https://im.cmgmxglobal.org'
  // : '/api',
  //HCF
  // baseURL:process.env.NODE_ENV == 'production'
  // ? 'https://im.api.hyundaicapitalfinancial.com'
  // : '/api',
  //SAM
  baseURL: process.env.NODE_ENV == 'production'
    ? 'https://im.api.samworkfinance.com'
    : '/api',
  // suzukifi
    // baseURL: process.env.NODE_ENV == 'production'
    // ? 'https://im.api.suzukifi.com'
    // : '/api',
    // pcpscale
    // baseURL: process.env.NODE_ENV == 'production'
    // ? 'https://im.api.pcpscale.com'
    // : '/api',
  timeout: 40000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  (config) => {
    const token = getToken()
    // do something before request is sent
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    config.headers['access-token'] = token
    const timestamp = Date.now()
    const sign = '213z@W!X#$%&'
    config.headers['X-timestamp'] = timestamp
    config.headers['X-sign'] = sha256(sign + JSON.stringify(config.data || {}) + timestamp)
    return config
  },
  (error) => {
    // console.log(error) // for debug
    // return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response
    if (res.data.code == 20002) {
      router.push('/login')
      removeToken()
      Message({
        message: res.data.message,
        type: 'error',
        duration: 5 * 1000
      })
      return
    }
    if (res.data.code !== 20000) {
      Message({
        message: res.data.message,
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      return res
    }
  },
  (error) => {
    console.log('err' + error) // for debug
  }
)

export function get(url, params) {
  return service.get(url, {
    params
  })
}

export function post(url, data, meta = {}) {
  return service({
    url: url,
    method: 'post',
    data: data,
    meta: meta
  })
}
export function post1(url, data, meta = {}) {
  return service({
    url: url,
    method: 'post',
    data: data,
    meta: meta
  })
}

export function del(url) {
  return service.delete(url)
}

export function put(url, data) {
  return service.put(url, data)
}

export default service
